module.exports = __webpack_public_path__ + "img/p8_1.6b30a5ba.png";